// extracted by mini-css-extract-plugin
export default {"background":"SKR4w7pmdz","light":"IWYrX5MUsn","dark":"KE9bUbMWj4"};